import React from "react";
import { TextField } from "@xfrontend/xui-react-plus";
import useUpdateEffect from "../../hooks/useUpdateEffect";

interface DebouncedTextFieldProps {
  value?: string;
  onChange: (value: string) => void;
  debounce?: number;
  [key: string]: unknown;
}

// A typical debounced input react component
export const DebouncedTextField = ({
  value: initialValue = "",
  onChange,
  debounce = 500,
  ...props
}: Readonly<DebouncedTextFieldProps>): JSX.Element => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useUpdateEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]);

  return (
    <TextField
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

export default DebouncedTextField;
